export const CLASSE_SHEET_INFERIOR = 'slide-modal-baixo';
export const CLASSE_SHEET_FECHADO_POR_ARRASTE = 'sheet-fechado-por-arraste';
export const LIMIAR_INICIO_ARRASTE_SHEET = 8;
export const FRACAO_ALTURA_FECHAR_SHEET = 0.28;
export const VELOCIDADE_FECHAR_SHEET = 0.55;
export const DESLOCAMENTO_MINIMO_VELOCIDADE_SHEET = 40;
export const JANELA_VELOCIDADE_SHEET_MS = 100;
export const DURACAO_FECHAR_SHEET_MS = 220;
export const DURACAO_VOLTAR_SHEET_MS = 260;
export const OPACIDADE_MINIMA_FUNDO_SHEET = 0.15;
export const CURVA_SHEET = 'cubic-bezier(0.2, 0, 0, 1)';
export const SELETOR_IGNORAR_ARRASTE_SHEET = 'input, textarea, select, [role="slider"], [contenteditable="true"], .sem-arrastar-sheet';
export const LARGURA_MAXIMA_SHEET_PX = 767;
